var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasksIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_137_9513)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_137_9513",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_137_9513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.625 20C4.15833 20 3.771 19.846 3.463 19.538C3.15433 19.2293 3 18.8417 3 18.375V5.625C3 5.15833 3.15433 4.771 3.463 4.463C3.771 4.15433 4.15833 4 4.625 4H19.375C19.8417 4 20.2293 4.15433 20.538 4.463C20.846 4.771 21 5.15833 21 5.625V18.375C21 18.8417 20.846 19.2293 20.538 19.538C20.2293 19.846 19.8417 20 19.375 20H4.625ZM4.625 19H19.375C19.5417 19 19.6873 18.9373 19.812 18.812C19.9373 18.6873 20 18.5417 20 18.375V5.625C20 5.45833 19.9373 5.31267 19.812 5.188C19.6873 5.06267 19.5417 5 19.375 5H4.625C4.45833 5 4.31267 5.06267 4.188 5.188C4.06267 5.31267 4 5.45833 4 5.625V18.375C4 18.5417 4.06267 18.6873 4.188 18.812C4.31267 18.9373 4.45833 19 4.625 19ZM5.5 16.5H9.5V15.5H5.5V16.5ZM14.55 14.3L18.8 10.05L18.075 9.325L14.55 12.875L13.125 11.45L12.425 12.175L14.55 14.3ZM5.5 12.5H9.5V11.5H5.5V12.5ZM5.5 8.5H9.5V7.5H5.5V8.5Z",
    fill: "#1C1B1F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_137_9513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasksIcon);
export default __webpack_public_path__ + "static/media/tasks_icon.b3c41869ab2000d5777c7f01d66b7630.svg";
export { ForwardRef as ReactComponent };